import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { FaqHeroSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/faq/faq-hero-section';
import { FaqContent } from '@trashlab/sitesapp/src/organizations/redebins/template/components/faq/faq-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/service-areas-section';

const FaqPage = () => {
  return (
    <>
      <FaqHeroSection />
      <FaqContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/faq',
  component: FaqPage,
});

